/**
 * Safe JWT payload decoder for debugging.
 * Does not validate signatures and should only be used for logs.
 */
export function safeDecodeJwtPayload(token: string | null): Record<string, unknown> | null {
  if (!token) return null
  try {
    const parts = token.split('.')
    if (parts.length < 2) return null
    const payload = parts[1]
    // Pad base64 correctly and decode
    const normalized = payload.replace(/-/g, '+').replace(/_/g, '/')
    const padded = normalized + '='.repeat((4 - (normalized.length % 4)) % 4)
    const json = typeof atob === 'function'
      ? atob(padded)
      : Buffer.from(padded, 'base64').toString('utf8')
    return JSON.parse(json)
  } catch (e) {
    console.warn('jwt:safeDecodeJwtPayload failed to decode payload', e)
    return null
  }
}

export function summarizeClerkClaims(payload: Record<string, unknown> | null) {
  if (!payload) return null
  const orgMeta = (payload['org_metadata'] as Record<string, unknown> | undefined) || undefined
  return {
    sub: payload['sub'],
    org_id: payload['org_id'] || payload['organization_id'] || orgMeta?.['id'],
    org_slug: payload['org_slug'] || orgMeta?.['slug'],
    // Timestamps can help spot stale tokens
    iat: payload['iat'],
    exp: payload['exp'],
    // Include a minimal view of all top-level keys for quick inspection
    claim_keys: Object.keys(payload)
  }
}
